import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleDarkMode } from '../../HandleSlice/HandleSlice';
import { MdBedtime, MdContrast, MdSunny } from "react-icons/md";
import { useEffect } from 'react';
export default function Switcher(props) {
    const data = useSelector((data) => data.hamberger);
    const dispatch = useDispatch();
    const [darkState, setDarkState] = useState("bg-[#afafb6] dark:bg-gray-50")
    const [autoState, setAutoState] = useState("bg-[#afafb6] dark:bg-gray-50")
    const [lightState, setLightState] = useState("bg-[#afafb6] dark:bg-gray-50")

    function dark() {
        localStorage.setItem("theme", "dark")
        window.document.documentElement.classList.remove("light");
        window.document.documentElement.classList.add("dark");
        dispatch(handleDarkMode(!data.darkModeState))
        setDarkState("text-[#3d85b7] dark:bg-[#aaaaaa] bg-white ")
        setLightState("bg-[#afafb6] dark:bg-gray-50")
        setAutoState("bg-[#afafb6] dark:bg-gray-50")
        localStorage.setItem("autoDarkMode", "false")
    }

    function light() {
        localStorage.setItem("theme", "light")
        window.document.documentElement.classList.remove("dark");
        window.document.documentElement.classList.add("light");
        dispatch(handleDarkMode(!data.darkModeState))
        setLightState("text-[#ff9900] dark:bg-[#aaaaaa] bg-white")
        setDarkState("bg-[#afafb6] dark:bg-gray-50")
        setAutoState("bg-[#afafb6] dark:bg-gray-50")
        localStorage.setItem("autoDarkMode", "false")
    }

    function auto() {
        if (localStorage.getItem("theme") === "light") {
            setAutoState("text-[#0fa862] dark:bg-[#aaaaaa] bg-white")
            setLightState("bg-[#afafb6] dark:bg-gray-50")
            setDarkState("bg-[#afafb6] dark:bg-gray-50")
        } else if (localStorage.getItem("theme") === "dark") {
            setAutoState("text-[#3d85b7] dark:bg-[#aaaaaa] bg-white")
            setLightState("bg-[#afafb6] dark:bg-gray-50")
            setDarkState("bg-[#afafb6] dark:bg-gray-50")
        }
        localStorage.setItem("autoDarkMode", "true")
        props.setAutoDarkModeState(!props.autoDarkModeState)
    }



    useEffect(() => {
        switch (props.localTheme) {
            case "light":
                light();
                break;
            case "dark":
                dark()
                break;
            default:
                light()
                break;
        }
        document.body.classList.add("dark:bg-[#152A38]")
        document.body.classList.add("bg-[#EAEDF7]")
    }, [])

    return (
        <>
            <div className='flex items-center'>
                <button className={`p-1 rounded-full cursor-pointer z-[2] hover:rotate-[360deg] transition-transform duration-1000 shadow-[0_0_5px_1px_rgba(0,0,0,0.2)] ${darkState} `} onClick={dark}>
                    <MdBedtime />
                </button >
                <div className='w-[20px] h-3.5 bg-[#afafb6] dark:bg-gray-50 mr-[-5px] ml-[-5px]'></div>
                <button className={`p-1 rounded-full cursor-pointer z-[2] hover:rotate-[360deg] transition-transform duration-1000 shadow-[0_0_5px_1px_rgba(0,0,0,0.2)] ${autoState} `} onClick={auto}>
                    <MdContrast />
                </button>
                <div className='w-[20px] h-3.5 bg-[#afafb6] dark:bg-gray-50 mr-[-5px] ml-[-5px]'></div>
                <button className={`p-1 rounded-full cursor-pointer z-[2] hover:rotate-[360deg] transition-transform duration-1000 shadow-[0_0_5px_1px_rgba(0,0,0,0.2)] ${lightState} `} onClick={light}>
                    <MdSunny />
                </button>
            </div>
        </>
    );
}